const trackSignUp = () => {
  if (!window.gtag) {
    return;
  }
  gtag('event', 'conversion', { send_to: 'AW-852381475/soioCKz5jfUBEKOeuZYD' });
};

export { trackSignUp };
